import React from "react";
import { connect } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import NotificationsIcon from "@material-ui/icons/Notifications";

function index({
  settings,
  dismissNotification,
  isNotificationDismissed,
  isB2B,
  language,
  checkB2Broute,
}) {
  if (!settings || !settings.enable_banner || isNotificationDismissed || isB2B || checkB2Broute)
    return <></>;
  return (
    <div
      className="bannerLargeScreen"
      style={{
        minHeight: 50,
        backgroundColor: settings.banner_color,
        position: "fixed",
        top: 0,
        zIndex: 402,
        left: language == "english" && 0,
        right: language == "arabic" && 0,
        width: "100%",
        direction: language == "english" ? "ltr" : "rtl",
      }}
    >
      <div className="row w-100 m-auto">
        <div className="col-2" style={{ lineHeight: "50px", padding: 0 }}>
          <NotificationsIcon style={{ color: "white", fontSize: 25 }} />
        </div>
        <div
          className="col-8 cut-text-two-lines-banner"
          style={{
            color: "white",
            fontSize: 13,
            maxHeight: 50,
            margin: "auto",
            padding: 0,
          }}
        >
          {language == "english"
            ? settings.banner_english
            : settings.banner_arabic}
        </div>

        <div
          className="col-2"
          style={{ lineHeight: "50px", padding: 0 }}
          onClick={() => dismissNotification()}
        >
          <CloseIcon style={{ color: "white", fontSize: 25 }} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    isNotificationDismissed: state.store.isNotificationDismissed,
    language: state.store.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dismissNotification: () => dispatch({ type: "DISMISS_NOTIFICATION" }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
